import React from 'react'
import BaseIcon from 'react-icon-base'

const TW = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>TW</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="2" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#FFF" xlinkHref="#a" />
      <g mask="url(#b)">
        <path fill="#D9242A" d="M0 15h22.5V0H0z" />
        <path fill="#292C6D" d="M0 7.5h11.25V0H0z" />
        <path
          fill="#FFFFFE"
          d="M5.623 5.151a1.402 1.402 0 1 0 0-2.803 1.402 1.402 0 0 0 0 2.803M5.952 2.17L5.623.944l-.33 1.23c.174-.041.438-.051.66-.002M5.119 2.218l-.899-.899.33 1.23c.129-.123.353-.263.569-.331"
        />
        <path
          fill="#FFFFFE"
          d="M4.42 2.675l-1.227-.329.9.901c.051-.171.174-.405.327-.572M4.044 3.42l-1.227.33 1.23.329a1.6 1.6 0 0 1-.003-.659M4.091 4.254l-.898.899 1.23-.33a1.601 1.601 0 0 1-.332-.57M4.549 4.952L4.22 6.18l.9-.901a1.6 1.6 0 0 1-.571-.327M5.294 5.328l.33 1.228.329-1.23a1.6 1.6 0 0 1-.659.002M6.128 5.281l.898.899-.33-1.23a1.6 1.6 0 0 1-.568.331M6.826 4.824l1.228.329-.901-.901c-.05.17-.174.404-.327.572M7.202 4.078L8.43 3.75l-1.231-.33c.042.174.052.438.003.66M7.155 3.245l.899-.899-1.231.33a1.6 1.6 0 0 1 .332.569M6.697 2.547l.33-1.228-.901.9a1.6 1.6 0 0 1 .571.328"
        />
      </g>
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default TW
